<template>
  <div v-if="hasVisibleItems">
    <div
      class="px-2 pb-1 pt-3 text-left text-xs font-semibold uppercase tracking-wider text-obsidian-500"
    >
      {{ label }}
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  hasVisibleItems: boolean;
}>();
</script>
